import { getCurrentUser, fetchAuthSession } from "aws-amplify/auth";
import { useEffect, useState } from "react";

export interface AuthUser {
    username: string;
    attributes: { email: string };
}

export const useAuth = () => {
    const [user, setUser] = useState<AuthUser | null>(null);
    const [token, setToken] = useState<string | undefined>();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const initializeAuth = async () => {
            try {
                setLoading(true);
                setError(null);

                // Get current authenticated user (v6 API)
                const currentUser = await getCurrentUser();
                
                // Get session token (v6 API)
                const session = await fetchAuthSession();
                const jwtToken = session.tokens?.idToken?.toString();
                
                if (currentUser && jwtToken) {
                    setUser({
                        username: currentUser.username,
                        attributes: { email: currentUser.signInDetails?.loginId || '' }
                    });
                    setToken(jwtToken);
                }
            } catch (error) {
                // Auth error occurred
                setError(error instanceof Error ? error.message : 'Authentication failed');
            } finally {
                setLoading(false);
            }
        };

        initializeAuth();
    }, []);

    return {
        user,
        token,
        loading,
        error,
        isAuthenticated: !!user && !!token,
    };
}; 